<template>
	<section class="topbar">
		<div :class="{ 'container': container }" class="topbar-row">
			<div class="topbar-col" v-if="!this.$slots.left && !this.$slots.left">
				<div class="topbar-title" v-if="title" v-html="title || ''"></div>
				<slot></slot>
			</div>

			<div class="topbar-col left" v-if="this.$slots.left">
				<div class="topbar-title" v-if="title" v-html="title"></div>
				<slot name="left"></slot>
			</div>

			<div class="topbar-col right" v-if="this.$slots.right">
				<slot name="right"></slot>
			</div>
		</div>
	</section>
</template>

<script>
	export default {
		props: {
			title: {
				type: String,
				default: '',
				required: false,
			},
			container: {
				type: Boolean,
				default: false,
				required: false,
			},
		},

		methods: {},
	}
</script>

<style lang="stylus" scoped>
	@import './styles.styl'
</style>
